var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6263 21.032C12.6757 19.3046 16.3221 17.167 19.2871 19.2773M32.0528 16.4057C30.2332 15.176 26.6527 15.6445 25.3014 18.2341M14.7959 27.0772C18.1417 35.3792 32.8159 31.3971 31.6813 22.6111C31.6813 22.6111 28.4723 24.168 23.894 25.379C19.3156 26.59 14.7959 27.0772 14.7959 27.0772ZM37.9292 18.8519C38.8786 29.7361 30.1403 37.4626 20.2598 37.5933C10.3793 37.7241 3.64575 32.0074 2.16953 21.9566C0.69331 11.9057 9.08723 2.87625 18.4198 2.06599C27.7523 1.25573 36.9798 7.96766 37.9292 18.8519Z",
    stroke: "#1B3B5F",
    strokeWidth: 2.02247
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.ed0e4452c7abc62895d05058faccafa8.svg";
export { ForwardRef as ReactComponent };